<template>
    <el-dialog title="操作说明" :visible.sync="isShow" width="640px" class="" @close="closeDialog">
        <div>
            <img src="@/assets/images/recharge/rechare-card.png" class="img-width"  alt="">
        </div>   
    </el-dialog>
</template>
<script>
export default {
    name: 'rechareCardHelp',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {

            isShow: this.visible,
        }
    },
    watch: {
        visible(val) {
            this.isShow = val;
        }
    },
    mounted() {

    },
    methods: {

        closeDialog() {
            this.$emit('update:visible', false);
            this.isShow = false;
        }
    }
}
</script>
<style lang="scss" scope>
.img-width{
    width: 100%;
}

</style>